<template>
  <div :class="size" :style="inputStyle">
    <div class="input-group" :class="disabled ? 'disabled' : ''">
      <span :style="unitRequired ? { width: '15em' } : { width: '100%' }">
        <input
          :type="type"
          class="form-control"
          :placeholder="placeholder"
          :value="value"
          @input="updateValue($event)"
          min="0"
          :maxlength="maxLength"
          :id="id"
          style="width: 100%"
          :disabled="disabled"
          @keydown="keydown($event)"
        />
      </span>
      <div
        v-if="unitRequired"
        class="input-group-append"
        style="border-left: 0.1em rgba(255, 255, 255, 0.3) solid"
      >
        <span
          v-if="isDropdown"
          style="
            'border-right': '0.13em rgba(255, 255, 255, 0.3) solid;' 
          "
        >
          <RexSearchSelect
            :data="options"
            :current="currentDropdown"
            @onChoose="onChange"
            width="5.75em"
            :borderEnable="false"
            :isSearch="false"
            id="search-select-metric-type"
          />
        </span>
        <span v-else>
          {{ unitAppend }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
export default {
  components: {
    RexSearchSelect,
  },
  name: 'RexFormInputDropdown',

  data() {
    return {
      inputVal: '',
      currentDropdown: {},
      open: false,
      defaultValueHandler: {
        type: Function,
        required: false,
      },
    };
  },

  props: {
    isDropdown: { type: Boolean, default: false },
    unit: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    defualtOptions: { type: Object, default: () => {} },
    placeholder: { type: String, default: '' },
    type: { type: String, default: 'text' },
    id: { type: String, required: true },
    size: { type: String, default: 'sm' },
    inputStyle: { type: String },
    unitRequired: { type: Boolean, default: false },
    value: {},
    disabled: { type: Boolean, default: false },
    maxLength: { type: Number, default: -1 },
  },
  methods: {
    onChange(current) {
      this.currentDropdown = current;
      this.emitValue(current);
    },
    emitValue(current) {
      this.$emit('update', current);
    },
    updateValue: function (event) {
      if (this.maxLength > 0) {
        event.target.value = event.target.value.slice(0, this.maxLength);
      }
      this.$emit('update', event.target.value);
    },
    keydown(event) {
      if (this.maxLength > 0) {
        event.target.value = event.target.value.slice(0, this.maxLength);
      }
      this.$emit('keydown', event);
    },
  },
  mounted() {
    this.currentDropdown = this.defualtOptions;
  },
  // mounted() {
  //   if (this.updateVal) {
  //     this.inputVal = this.updateVal;
  //   }
  // },
  computed: {
    unitAppend() {
      if (this.unit === '') {
        return '';
      }
      return '| ' + this.unit;
    },
  },
  watch: {
    defualtOptions(newValue, oldValue) {
      this.currentDropdown = newValue;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-control {
  background-color: $bg-primary;
  color: $font-primary;
  //border: 0.0625 black solid;
  height: 100%;
}
.input-last {
  background-color: $bg-primary;
  border: 0.125em;
}
.sm {
  min-width: 12.5em;
}
.lg {
  min-width: 18.75em;
}
.input-group-text {
  color: $font-primary;
  background: $bg-primary;
  border: none;
}
.input-group-append {
  border-top-right-radius: 0.375em;
  border-bottom-right-radius: 0.375em;
  color: $font-primary;
  background-color: $bg-primary;
  // padding: 0.3125em;
  text-align: left;
}
.input-group {
  background: $bg-primary;
  border-radius: 0.375rem;
  border: 0.0625em $border-primary solid;
  height: 100%;
  flex-wrap: nowrap !important;
}
input[type='number'] {
  box-sizing: border-box;
  border: none;
  border-radius: 0.375rem;
  background-color: $bg-primary;
  color: $font-primary;
  -moz-appearance: textfield;
}
.cust-modal-input:focus {
  outline: none !important;
}
input:focus {
  outline: none !important;
  box-shadow: none;
}
.disabled {
  color: $border-color-primary-disabled;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
